<template>
  <asd20-app-template
    sidebar-icon="filter"
    :sidebar-badge="totalFiltersApplied"
    searchable
    :keywords.sync="keywords"
    title="Documents & Forms"
    icon="files"
    :version="version"
  >
    <template #sidebar-title>
      <span class="app-title">Filter</span>
      <asd20-button
        id="clear-button"
        v-if="totalFiltersApplied"
        transparent
        horizontal
        size="sm"
        icon="close"
        label="Clear"
        @click.native="clearFilters"
      />
    </template>

    <asd20-button
      v-if="isAdmin && editing"
      slot="toolbar-end"
      icon="file"
      size="sm"
      horizontal
      transparent
      label="Add File"
      @click.native="addFile"
    />

    <template #sidebar>
      <asd20-file-filters />
    </template>

    <asd20-list>
      <asd20-list-item
        v-for="(item, index) in filteredFilesListItems"
        :key="index"
        v-bind="item"
        @click.native="
          isAdmin && editing ? onFileEdit(item) : onFileClick(item)
        "
      >
        <asd20-button
          v-if="isAdmin && editing"
          slot="actions"
          horizontal
          transparent
          label="Download"
          @click.native.stop="onFileClick(item)"
        />
      </asd20-list-item>
    </asd20-list>
    <Asd20FileModal
      :file="selectedFile"
      :open="!!selectedFile"
      @dismiss="selectedFile = null"
    />
  </asd20-app-template>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import { version } from '../../../package.json'
import Asd20AppTemplate from '@asd20/ui/src/components/templates/Asd20AppTemplate'
import Asd20FileFilters from '../../components/organisms/Asd20FileFilters'
import Asd20FileModal from '../../components/organisms/Asd20FileModal'
import Asd20List from '@asd20/ui/src/components/organisms/Asd20List'
import Asd20ListItem from '@asd20/ui/src/components/molecules/Asd20ListItem'
import syncronizedQueryParameters from '../../mixins/syncronizedQueryParameters'

export default {
  name: 'Asd20FileSearchPage',

  mixins: [syncronizedQueryParameters],

  components: {
    Asd20AppTemplate,
    Asd20FileFilters,
    Asd20List,
    Asd20ListItem,
    Asd20FileModal,
  },
  data: () => ({
    pageTransition: 'fade',
    selectedFile: null,
    version,
    syncronizedQueryParameters: [
      {
        componentKey: 'selectedCategories',
        queryKey: 'selectedCategories',
        forceArray: true,
      },
      {
        componentKey: 'selectedOrganizationIds',
        queryKey: 'selectedOrganizationIds',
        forceArray: true,
      },
    ],
  }),

  computed: {
    filteredFilesCount: get('files/filteredFilesCount'),
    filteredFilesListItems: get('files/filteredFilesListItems'),
    totalFiltersApplied: get('files/totalFiltersApplied'),
    keywords: sync('files/keywords'),
    selectedCategories: sync('files/selectedCategories'),
    selectedOwners: sync('files/selectedOwners'),
    editing: sync('files/editing'),
    isAdmin: get('auth/isAdmin'),
    isAuthenticated: get('auth/isAuthenticated'),
    accessToken: get('auth/accessToken'),
    userProfile: get('auth/userProfile'),
    owners: get('files/owners'),
    selectedOrganizationIds: sync('files/selectedOrganizationIds')
    // groupedCategoryOptions: get('files/groupedCategoryOptions'),
  },

  methods: {
    clearFilters() {
      this.$store.dispatch('files/clearFilters')
    },
    onFileClick(item) {
      window.open(item.file.url, '_blank')
    },
    onFileEdit(item) {
      this.selectedFile = item.file
    },

    async signIn() {
      if (!this.isAuthenticated) {
        await this.$store.dispatch('auth/signIn')
      }
      if (this.isAdmin && !this.editing) {
        this.editing = true
      } else {
        this.editing = false
      }
    },

    addFile() {
      this.selectedFile = {
        type: 'file',
        name: '',
        slug: '',
        description: '',
        categories: [],
        owners: [],
        url: '',
        downloadUrl: '',
        filename: '',
        filetype: '',
        filesize: 0,
        mimeType: '',
        sourceId: '',
        sourceContext: '',
        createdBy: '',
        createdDateTime: '',
        lastModifiedDateTime: '',
        lastModifiedBy: '',
        organizationIds: []
      }
    },
  },

  mounted() {
    // Shortcut key to login
    if (document) {
      document.onkeyup = e => {
        if (e.key === '`' || e.key === '~') {
          this.signIn()
        }
      }
    }
  },
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_mixins.scss';
@import '@asd20/ui/src/design/_variables.scss';

.app-title{
  font-size: 1em;
}

.asd20-tag-group .asd20-tag{
  color: var(--color__primary);
}

.asd20-app-template__main {
  overflow-y: auto;
}

#clear-button {
  display: none;
  margin-left: 0;
}

@media (min-width: 1024px) {
  #clear-button {
    display: inherit;
  }
  .asd20-app-template__main {
    padding: space(1);
  }
  .app-title{
    font-size: .75em;
  }
}
</style>
